import React, { useEffect, useState } from "react";
import "./planpagelayout.css";
import { useDispatch, useSelector } from "react-redux";
import {
  QuickQuoteLife,
  PostQuoteLife,
  ErrQuotesLife,
  SelectedPayTill,
  PayTillUpdate,
} from "../../Redux/actions/NumLife";
import { Button, Form, Select, message } from "antd/lib";
import axiosInLife from "../../Redux/axios/AxiosInLife";
import YearDataLife from "../Number LifePage/YearData";

export default function PayTillAge({ setisModalPayTill, coverTill }) {
  console.log(coverTill);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const LifeNum = useSelector((state) => state?.lifedetail?.lifenum);
  const QuotePost = useSelector((state) => state?.lifedetail?.QuickQuotePost);
  const SQQPlanMode = useSelector((state) => state?.common?.selectedLifePlan);
  const Paytill = useSelector((state) => state?.common?.paytillAge);
  const [loading, setLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [PremTerm, setPremTerm] = useState("");
  console.log(QuotePost);

  const handleSelectChange = (value) => {
    console.log("valueee", value);
    setSelectedValue(value);
    const AddAge6 = parseInt(QuotePost?.Age) + 6;
    const AddAge8 = parseInt(QuotePost?.Age) + 8;
    const AddAge10 = parseInt(QuotePost?.Age) + 10;
    const AddAge15 = parseInt(QuotePost?.Age) + 15;

    if (QuotePost?.PolicyTerm === "10" && value >= AddAge6) {
      // console.log('10---66666666');
      setPremTerm("6");
    } else if (
      value >= AddAge15 ||
      (value > AddAge10 && QuotePost?.PolicyTerm === "15")
    ) {
      // console.log('1555555');
      setPremTerm("15");
    } else if (value >= AddAge10 || value > AddAge8) {
      //  console.log('10000000');
      setPremTerm("10");
    } else if ((value == AddAge8 && value < AddAge10) || value > AddAge6) {
      //  console.log('88888888888');
      setPremTerm("8");
    } else if (
      (value =
        (AddAge6 && value < AddAge8 && QuotePost?.PolicyTerm === "10") ||
        QuotePost?.PolicyTerm === "12")
    ) {
      //  console.log('66666666');
      setPremTerm("6");
    } else if (
      (value = AddAge6 && value < AddAge8 && QuotePost?.PolicyTerm === "15")
    ) {
      // console.log('15-66666666');
      setPremTerm("6");
    }
  };

  const filteredAgeData = YearDataLife?.filter((item) => {
    const PostAge = parseInt(QuotePost?.Age) + 5;
    const age = parseInt(item.label.split(" ")[0]);
    return age >= PostAge && age <= coverTill;
  });

  const handlePayOnceClick = () => {
    const payOnceValue = "Single Pay";
    console.log(payOnceValue);
    form.setFieldsValue({ payTillAge: "Single Pay" });
    document.activeElement.blur();
  };

  const onFinish = (values) => {
    console.log("product values", values);
    const UpdatePlan = {
      ...QuotePost,
      PremiumTerm: PremTerm,
    };
    setLoading(true);
    // axiosInLife
    // .post(`v1/life_insurances/${LifeNum?.insurance_id}/quick_quotes`, UpdatePlan)
    //   .then((res) => {
    //     if (res.status === 200) {
    //   const data = res?.data?.data
    // console.log(data)
    //   const filteredData = data?.filter(item => ("status" in item && item.status === "success"));
    //   const updatedData = filteredData?.map((item) => ({
    //     ...item,
    //     responses: item.responses.map((response) => ({
    //       ...response,
    //       ...response[SQQPlanMode],
    //       insurer: item.insurer,
    //       logo: item.logo,
    //     })),
    //   }));
    // console.log('updatedDataaaa',updatedData);
    // dispatch(QuickQuoteLife(updatedData));
    setTimeout(() => {
      dispatch(PostQuoteLife(UpdatePlan));
      dispatch(SelectedPayTill(values?.payTillAge));
      dispatch(PayTillUpdate(values?.payTillAge));
      setLoading(false);
      setisModalPayTill(false);
    }, 500);

    //   }
    // })
    // .catch((err) => {
    //   console.log(err.response.data.error);
    //   setLoading(false)
    //   message.error(err.response.data.error);
    // });
  };

  return (
    <>
      <Form
        onFinish={onFinish}
        layout="vertical"
        requiredMark={false}
        form={form}
      >
        <Form.Item
          name="payTillAge"
          rules={[
            {
              required: true,
              message: "please select Income",
            },
          ]}
          // initialValue={coverTill}
        >
          <Select
            showArrow={false}
            className="life-age-select"
            style={{ textAlign: "left" }}
            placeholder="Pay Till"
            onChange={handleSelectChange}
            // onSelect={handleSelectChange}
            // value={selectedValue}
            // open={dropdownVisible}
            onFocus={() => setDropdownVisible(true)}
            onBlur={() => setDropdownVisible(false)}
            dropdownRender={(menu) => (
              <div>
                {menu}
                <Button
                  type="primary"
                  style={{ width: "100%" }}
                  onClick={handlePayOnceClick}
                >
                  Pay once
                </Button>
              </div>
            )}
          >
            {filteredAgeData?.map((p) => (
              <Select.Option key={p.value} value={p.value}>
                {p.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item style={{ textAlign: "right" }}>
          <Button
            type="primary"
            htmlType="submit"
            className="update-qut-button"
            loading={loading}
          >
            Update
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
